import { withAsync } from './withAsync'
import { graphql } from './graphql'

export const withData = (q) => withAsync(() => graphql(q).catch((err) => console.log(err)))
export default withData



// WEBPACK FOOTER //
// ./src/withData.js